import React from "react";
import ReactDOM from "react-dom";
import { I18n } from "ceco-polyglot";
import Router from "./router/Router";
import * as serviceWorker from "./serviceWorker";
import "cecoadmin-theme/dist/semantic.min.css";
import "./index.scss";

const locale = "es";

//TODO: Avoid having to wait for translation to start rendering page (move to App.js with state)
import(`./i18n/${locale}/translations.json`).then(({ default: phrases }) => {
  ReactDOM.render(
    <I18n locale={locale} phrases={phrases}>
      <Router />
    </I18n>,
    document.getElementById("root")
  );
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
